import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const TrashCanIcon = ({ color = '#000', style = {}, size = 'sm', ...attr }) => {
  return (
    <svg {...iconSizes[size]} style={style} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M-6.10352e-05 5.5H2.99994M2.99994 5.5H4.99994M2.99994 5.5V16.5H12.9999V5.5M4.99994 5.5H10.9999M4.99994 5.5V4.5C4.99994 2.84315 6.34308 1.5 7.99994 1.5C9.65679 1.5 10.9999 2.84315 10.9999 4.5V5.5M10.9999 5.5H12.9999M12.9999 5.5H15.9999" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default TrashCanIcon;
